import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import Highcharts from 'highcharts/highstock.src';
import SeriesLabel from 'highcharts/modules/series-label';
import NoData from 'highcharts/modules/no-data-to-display';
SeriesLabel(Highcharts);
NoData(Highcharts);

ko.bindingHandlers.chartType = {
    update: function (element, valueAccessor, allBindings) {
        var dataAndOptions = ko.unwrap(allBindings.get('dataAndOptions'));

        var id = dataAndOptions.id;
        var data = dataAndOptions.data;

        var chartobj = ko.utils.domData.get(element, "chartjs.instance" + id);
        if (chartobj) {
            chartobj.destroy();
        }

        chartobj = Highcharts.chart(element, data);
        if (data && data.xAxis && data.xAxis.type === 'datetime') {
            if (data.series && data.series.length > 1) {
                chartobj.container.classList.add('hc-series-' + Math.min(10,data.series.length));
            }
        } else if (data.series && data.series.length > 0 && data.series[0].data && data.series[0].data.length > 1) {
            chartobj.container.classList.add('hc-series-'+ Math.min(10, data.series[0].data.length));
        }

        ko.utils.domData.set(element, "chartjs.instance" + id, chartobj);

        if (dataAndOptions.reflowSignal) {
            dataAndOptions.reflowSignal.add(reflow);
        }

        function reflow(delay) {
            if (!_.isEmpty(chartobj)) {
                // timeout needed to reflow charts after sidebar show/hide animations.
                setTimeout(function() { chartobj.reflow(); }, (delay || 0));
            }
        }

    }
};
